export const VIEW_TEMPLATE_TYPE_COLORLESS = 1;
export const VIEW_TEMPLATE_TYPE_FANCY = 2;
export const VIEW_TEMPLATE_TYPE_JEWELRY = 3;
export const VIEW_TEMPLATE_TYPE_ROUGH = 4;
